<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-toolbar
            customize-field-name="langsch"
            show-defined-list>
          </jm-toolbar>
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-row class="searchForm" :gutter="10">
              <el-col :span="6" v-if="constDict.country">
                国家：
                <el-select v-model="searchData.sh_mg_id" @change="changeCountry">
                  <el-option
                    v-for="item in constDict.country.filter(item=>(item.sh_mg_id===238 || item.sh_mg_id===240))"
                    :key="'ct_id' + item.sh_mg_id"
                    :label="item.title"
                    :value="item.sh_mg_id"/>
                </el-select>
              </el-col>
              <el-col :span="6">
                院校名称：
                <el-select v-model="searchData.sh_id" @change="changeSchool" filterable clearable>
                  <el-option
                    v-for="item in shOption"
                    :key="'sh_id'+item.sh_id "
                    :label="item.sh_name_cn"
                    :value="item.sh_id"/>
                </el-select>
              </el-col>


            </el-row>
            <el-row class="jm-tac" :gutter="10">
              <el-col :span="24">
                <el-button type="primary" @click="init">搜索</el-button>
              </el-col>
            </el-row>
            <jm-tableList
              v-if="searchData"
              url="/index/langsch/getList"
              :refresh="refresh"
              :search-data="searchData">
              <el-table-column
                slot="pf_url"
                slot-scope="scope"
                v-bind="scope.attrs"
                :label="scope.label"
                property="pf_url">
                <template slot-scope="scope">
                  <a :href="scope.row.pf_url" target="_blank">{{ scope.row.pf_url }}</a>
                </template>
              </el-table-column>
              <template>
                <el-table-column
                  fixed="right"
                  slot="lastColumn"
                  label="操作"
                  min-width="150">
                  <template slot-scope="scope">
                    <a :href="scope.row.pf_admin_url" target="_blank" v-if="$hasPermission([62, 173])">
                      <el-button type="primary">编辑</el-button>
                    </a>
                  </template>
                </el-table-column>
              </template>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmTableList from '@/components/data/tableList';
import toolbar from '@/components/tool/toolbar.vue';

let constDict = {};
let shOption = {};
let dpOption = {};
let xbOption = {};

export default {
  data() {
    return {
      constDict,
      shOption,
      dpOption,
      xbOption,
      refresh: false,
      searchData: {
        sh_mg_id: 238,
        sh_id: '',
        sh_name: '',
      },
      timeout: null,
    };
  },
  components: { jmTableList, 'jm-toolbar': toolbar },
  created() {
    this.$http
      ._get({
        url: '/index/langsch/searchDict'
      })
      .then(({ data }) => {
        this.constDict = Object.assign({}, this.constDict, data);
        this.searchData.sh_mg_id = 238;
        this.$store.commit('updateRefresh', true);
        this.getSchoolOption();
      });
  },
  methods: {
    init() {
      this.$store.commit('updateRefresh', true);
    },
    // 国家改变
    changeCountry() {
      this.searchData.sh_id = '';
      this.getSchoolOption();
    },
    getSchoolOption() {
      this.$http
        ._get({
          url: `/index/langsch/getSchoolOption/mgid/${this.searchData.sh_mg_id}`
        })
        .then(({ data }) => {
          this.shOption = Object.assign({}, data.list);
        });
    },
  },
  watch: {
    // searchData: {
    //   handler: function () {
    //     clearTimeout(this.timeout);
    //     this.timeout = setTimeout(() => {
    //       this.$nextTick(this.init);
    //     }, 500);
    //   },
    //   deep: true
    // }
  }
};

</script>

<style scoped>
  #main-content {
    background-color: #f3f3f3;
  }
  .s_right {
    float: right;
  }
  .searchForm * {
    padding: 5px;
  }
  .rows {
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .rows .rows-div {
    background-color: #FFF;
    border-radius: 5px;
    padding: 10px 20px 20px 20px;
  }
  .rows .rows-div p {
    border-bottom: solid 1px #CCC;
    padding: 10px 0px;
  }
  .rows .rows-div .chart-div {
    height: 250px;
  }
  .s_title {
    font-size: 18px;
  }
  .blue {
    color: #409EFF;
  }
</style>
